class ReiandoMainProduct {
  constructor(section) {
    this.section = section;

    this.form = section.querySelector(
      '[data-reiando-product-form]'
    );

    this.variantInput = section.querySelector(
      '[data-reiando-variant-id]'
    );

    this.optionInputs = Array.from(
      section.querySelectorAll(
        '[data-reiando-option-input]'
      )
    );

    this.priceElement = section.querySelector(
      '[data-reiando-product-price]'
    );

    this.quantityInput = section.querySelector(
      '[data-reiando-quantity-input]'
    );

    this.quantityMinus = section.querySelector(
      '[data-reiando-quantity-minus]'
    );

    this.quantityPlus = section.querySelector(
      '[data-reiando-quantity-plus]'
    );

    this.addButton = section.querySelector(
      '[data-reiando-add-button]'
    );

    this.addButtonText = section.querySelector(
      '[data-reiando-add-button-text]'
    );

    this.messageElement = section.querySelector(
      '[data-reiando-product-message]'
    );

    this.variantsElement = section.querySelector(
      '[data-reiando-variants]'
    );

    /*
     * 刺繍サービス
     */
    this.embroiderySelect = section.querySelector(
      '[data-reiando-embroidery-select]'
    );

    this.embroideryDetails = section.querySelector(
      '[data-reiando-embroidery-details]'
    );

    this.embroideryItemsContainer = section.querySelector(
      '[data-reiando-embroidery-items]'
    );

    this.embroideryTemplate = section.querySelector(
      '[data-reiando-embroidery-template]'
    );

    this.embroideryModalOpenButton = section.querySelector(
      '[data-reiando-embroidery-modal-open]'
    );

    this.embroideryModal = section.querySelector(
      '[data-reiando-embroidery-modal]'
    );

    this.embroideryModalDialog = section.querySelector(
      '[data-reiando-embroidery-modal-dialog]'
    );

    this.embroideryModalCloseButtons = Array.from(
      section.querySelectorAll(
        '[data-reiando-embroidery-modal-close]'
      )
    );

    /*
     * ギフト包装
     */
    this.giftSelect = section.querySelector(
      '[data-reiando-gift-select]'
    );

    this.giftQuantityWrap = section.querySelector(
      '[data-reiando-gift-quantity-wrap]'
    );

    this.giftQuantityInput = section.querySelector(
      '[data-reiando-gift-quantity]'
    );

    this.giftModalOpenButton = section.querySelector(
      '[data-reiando-gift-modal-open]'
    );

    this.giftModal = section.querySelector(
      '[data-reiando-gift-modal]'
    );

    this.giftModalDialog = section.querySelector(
      '[data-reiando-gift-modal-dialog]'
    );

    this.giftModalCloseButtons = Array.from(
      section.querySelectorAll(
        '[data-reiando-gift-modal-close]'
      )
    );

    /*
     * Shopify情報
     */
    this.productUrl =
      section.dataset.productUrl || '';

    this.productTitle =
      section.dataset.productTitle || '';

    this.embroideryProductJsonUrl =
      section.dataset.embroideryProductJsonUrl || '';

    this.giftProductJsonUrl =
      section.dataset.giftProductJsonUrl || '';

    this.moneyFormat =
      section.dataset.moneyFormat || '{{amount}}';

    this.cartAddUrl =
      section.dataset.cartAddUrl || '/cart/add.js';

    this.cartJsonUrl =
      section.dataset.cartJsonUrl || '/cart.js';

    this.variants = this.parseVariants();
    this.currentVariant = this.getInitialVariant();
    this.embroideryProduct = null;
    this.embroideryProductPromise = null;
    this.giftProduct = null;
    this.giftProductPromise = null;
    this.embroideryModalLastFocused = null;
    this.giftModalLastFocused = null;
    this.isSubmitting = false;

    /*
     * イベント関数を固定
     */
    this.handleOptionChange =
      this.handleOptionChange.bind(this);

    this.handleQuantityMinus =
      this.handleQuantityMinus.bind(this);

    this.handleQuantityPlus =
      this.handleQuantityPlus.bind(this);

    this.handleQuantityInput =
      this.handleQuantityInput.bind(this);

    this.handleEmbroideryChange =
      this.handleEmbroideryChange.bind(this);

    this.handleEmbroideryCharacterInput =
      this.handleEmbroideryCharacterInput.bind(this);

    this.handleEmbroideryModalOpen =
      this.handleEmbroideryModalOpen.bind(this);

    this.handleEmbroideryModalClose =
      this.handleEmbroideryModalClose.bind(this);

    this.handleEmbroideryModalKeydown =
      this.handleEmbroideryModalKeydown.bind(this);

    this.handleGiftChange =
      this.handleGiftChange.bind(this);

    this.handleGiftQuantityInput =
      this.handleGiftQuantityInput.bind(this);

    this.handleGiftModalOpen =
      this.handleGiftModalOpen.bind(this);

    this.handleGiftModalClose =
      this.handleGiftModalClose.bind(this);

    this.handleGiftModalKeydown =
      this.handleGiftModalKeydown.bind(this);

    this.handleSubmit =
      this.handleSubmit.bind(this);

    this.bindEvents();

    /*
     * 初期表示
     */
    this.updateEmbroideryState();
    this.updateGiftState();
    this.updateVariantState(false);
  }

  /*
   * 商品バリエーション情報を取得
   */
  parseVariants() {
    if (!this.variantsElement) {
      return [];
    }

    try {
      return JSON.parse(
        this.variantsElement.textContent.trim()
      );
    } catch (error) {
      console.error(
        '商品バリエーション情報を読み込めませんでした。',
        error
      );

      return [];
    }
  }

  /*
   * 初期選択バリエーション
   */
  getInitialVariant() {
    if (!this.variantInput) {
      return this.variants[0] || null;
    }

    const currentId = String(
      this.variantInput.value
    );

    return (
      this.variants.find((variant) => {
        return String(variant.id) === currentId;
      }) ||
      this.variants[0] ||
      null
    );
  }

  /*
   * イベント登録
   */
  bindEvents() {
    this.optionInputs.forEach((input) => {
      input.addEventListener(
        'change',
        this.handleOptionChange
      );
    });

    this.quantityMinus?.addEventListener(
      'click',
      this.handleQuantityMinus
    );

    this.quantityPlus?.addEventListener(
      'click',
      this.handleQuantityPlus
    );

    this.quantityInput?.addEventListener(
      'change',
      this.handleQuantityInput
    );

    this.quantityInput?.addEventListener(
      'blur',
      this.handleQuantityInput
    );

    this.embroiderySelect?.addEventListener(
      'change',
      this.handleEmbroideryChange
    );

    this.embroideryItemsContainer?.addEventListener(
      'input',
      this.handleEmbroideryCharacterInput
    );

    this.embroideryModalOpenButton?.addEventListener(
      'click',
      this.handleEmbroideryModalOpen
    );

    this.embroideryModalCloseButtons.forEach((button) => {
      button.addEventListener(
        'click',
        this.handleEmbroideryModalClose
      );
    });

    this.giftSelect?.addEventListener(
      'change',
      this.handleGiftChange
    );

    this.giftQuantityInput?.addEventListener(
      'change',
      this.handleGiftQuantityInput
    );

    this.giftQuantityInput?.addEventListener(
      'blur',
      this.handleGiftQuantityInput
    );

    this.giftModalOpenButton?.addEventListener(
      'click',
      this.handleGiftModalOpen
    );

    this.giftModalCloseButtons.forEach((button) => {
      button.addEventListener(
        'click',
        this.handleGiftModalClose
      );
    });

    this.form?.addEventListener(
      'submit',
      this.handleSubmit
    );
  }

  /*
   * 選択中の商品オプション
   */
  getSelectedOptions() {
    const selectedOptions = [];

    this.optionInputs
      .filter((input) => input.checked)
      .sort((a, b) => {
        return (
          Number(a.dataset.optionPosition) -
          Number(b.dataset.optionPosition)
        );
      })
      .forEach((input) => {
        selectedOptions.push(input.value);
      });

    return selectedOptions;
  }

  /*
   * 選択内容に一致するバリエーション
   */
  findSelectedVariant() {
    const selectedOptions =
      this.getSelectedOptions();

    if (selectedOptions.length === 0) {
      return this.currentVariant;
    }

    return (
      this.variants.find((variant) => {
        if (
          !Array.isArray(variant.options) ||
          variant.options.length !==
            selectedOptions.length
        ) {
          return false;
        }

        return variant.options.every(
          (optionValue, index) => {
            return (
              String(optionValue) ===
              String(selectedOptions[index])
            );
          }
        );
      }) || null
    );
  }

  /*
   * 商品オプション変更
   */
  handleOptionChange() {
    this.currentVariant =
      this.findSelectedVariant();

    this.updateVariantState(true);
  }

  /*
   * 刺繍サービス変更
   */
  handleEmbroideryChange() {
    this.updateEmbroideryState();
    this.setMessage('');
  }

  /*
   * 刺繍文字入力
   */
  handleEmbroideryCharacterInput(event) {
    const input = event.target.closest(
      '[data-reiando-embroidery-character]'
    );

    if (!input) {
      return;
    }

    const normalizedCharacter =
      input.value
        .normalize('NFKC')
        .toUpperCase();

    const allowedCharacter =
      Array.from(normalizedCharacter).find(
        (character) => /^[A-Z1-9]$/.test(character)
      ) || '';

    input.value = allowedCharacter;
    input.setCustomValidity('');
  }

  /*
   * 現在の商品数量
   */
  getProductQuantity() {
    const quantity = Number.parseInt(
      this.quantityInput?.value,
      10
    );

    return Number.isFinite(quantity) && quantity > 0
      ? quantity
      : 1;
  }

  /*
   * 商品数量に合わせて刺繍入力欄を増減
   */
  syncEmbroideryItems() {
    if (
      !this.embroideryItemsContainer ||
      !this.embroideryTemplate
    ) {
      return;
    }

    const targetCount = this.getProductQuantity();
    let items = this.getEmbroideryItems();

    while (items.length < targetCount) {
      const fragment =
        this.embroideryTemplate.content.cloneNode(true);

      this.embroideryItemsContainer.appendChild(fragment);
      items = this.getEmbroideryItems();
    }

    while (items.length > targetCount) {
      items[items.length - 1].remove();
      items = this.getEmbroideryItems();
    }

    items.forEach((item, index) => {
      this.setupEmbroideryItem(item, index);
    });
  }

  /*
   * 刺繍入力欄一覧
   */
  getEmbroideryItems() {
    if (!this.embroideryItemsContainer) {
      return [];
    }

    return Array.from(
      this.embroideryItemsContainer.querySelectorAll(
        '[data-reiando-embroidery-item]'
      )
    );
  }

  /*
   * 刺繍入力欄へ商品番号と一意なIDを設定
   */
  setupEmbroideryItem(item, index) {
    const itemNumber = index + 1;
    const sectionId = this.section.dataset.sectionId || 'product';
    const title = item.querySelector(
      '[data-reiando-embroidery-item-title]'
    );
    const number = item.querySelector(
      '[data-reiando-embroidery-item-number]'
    );
    const characterLabel = item.querySelector(
      '[data-reiando-embroidery-character-label]'
    );
    const characterInput = item.querySelector(
      '[data-reiando-embroidery-character]'
    );
    const colorInputs = Array.from(
      item.querySelectorAll(
        '[data-reiando-embroidery-color]'
      )
    );

    const titleId =
      `ReiandoEmbroideryItem-${sectionId}-${itemNumber}`;
    const characterId =
      `ReiandoEmbroideryCharacter-${sectionId}-${itemNumber}`;
    const colorName =
      `ReiandoEmbroideryColor-${sectionId}-${itemNumber}`;

    item.dataset.reiandoEmbroideryItemIndex =
      String(itemNumber);

    if (title) {
      title.id = titleId;
    }

    if (number) {
      number.textContent = String(itemNumber);
    }

    if (characterLabel) {
      characterLabel.htmlFor = characterId;
    }

    if (characterInput) {
      characterInput.id = characterId;
      characterInput.setAttribute(
        'aria-labelledby',
        titleId
      );
    }

    colorInputs.forEach((input, colorIndex) => {
      const inputId =
        `${colorName}-${colorIndex + 1}`;
      const label = input.closest(
        '[data-reiando-embroidery-color-label]'
      );

      input.id = inputId;
      input.name = colorName;
      input.setAttribute(
        'aria-labelledby',
        titleId
      );

      if (label) {
        label.htmlFor = inputId;
      }
    });
  }

  /*
   * 刺繍欄の表示・必須状態を更新
   */
  updateEmbroideryState() {
    if (
      !this.embroiderySelect ||
      !this.embroideryDetails
    ) {
      return;
    }

    const isEnabled =
      this.embroiderySelect.value === '希望する';

    if (isEnabled) {
      this.syncEmbroideryItems();
    }

    this.embroideryDetails.hidden = !isEnabled;

    this.embroideryDetails.setAttribute(
      'aria-hidden',
      isEnabled ? 'false' : 'true'
    );

    this.getEmbroideryItems().forEach((item) => {
      const characterInput = item.querySelector(
        '[data-reiando-embroidery-character]'
      );
      const colorInputs = Array.from(
        item.querySelectorAll(
          '[data-reiando-embroidery-color]'
        )
      );

      if (characterInput) {
        characterInput.disabled = !isEnabled;
        characterInput.required = isEnabled;

        if (!isEnabled) {
          characterInput.setCustomValidity('');
        }
      }

      colorInputs.forEach((input, index) => {
        input.disabled = !isEnabled;
        input.required = isEnabled && index === 0;

        if (!isEnabled) {
          input.setCustomValidity('');
        }
      });
    });
  }

  /*
   * 刺繍指定一覧を取得
   */
  getEmbroiderySelections() {
    return this.getEmbroideryItems().map(
      (item, index) => {
        const characterInput = item.querySelector(
          '[data-reiando-embroidery-character]'
        );
        const colorInput = item.querySelector(
          '[data-reiando-embroidery-color]:checked'
        );

        return {
          itemNumber: index + 1,
          character:
            characterInput?.value.trim() || '',
          color: colorInput?.value || ''
        };
      }
    );
  }

  /*
   * 刺繍入力を検証
   */
  validateEmbroidery() {
    if (
      !this.embroiderySelect ||
      this.embroiderySelect.value !== '希望する'
    ) {
      return true;
    }

    this.syncEmbroideryItems();

    const items = this.getEmbroideryItems();

    if (items.length !== this.getProductQuantity()) {
      return false;
    }

    for (const item of items) {
      const characterInput = item.querySelector(
        '[data-reiando-embroidery-character]'
      );
      const colorInputs = Array.from(
        item.querySelectorAll(
          '[data-reiando-embroidery-color]'
        )
      );

      if (!characterInput) {
        return false;
      }

      const character = characterInput.value
        .trim()
        .normalize('NFKC')
        .toUpperCase();

      if (!/^[A-Z1-9]$/.test(character)) {
        characterInput.setCustomValidity(
          '半角英大文字A〜Z、または数字1〜9を1文字入力してください。'
        );
        characterInput.reportValidity();
        return false;
      }

      characterInput.value = character;
      characterInput.setCustomValidity('');

      const selectedColor = colorInputs.some(
        (input) => input.checked
      );

      if (!selectedColor) {
        const firstColor = colorInputs[0];

        if (firstColor) {
          firstColor.setCustomValidity(
            '刺繍カラーを選択してください。'
          );
          firstColor.reportValidity();
          firstColor.setCustomValidity('');
        }

        return false;
      }
    }

    return true;
  }

  /*
   * ギフト包装変更
   */
  handleGiftChange() {
    this.updateGiftState();
    this.setMessage('');
  }

  /*
   * 包装数を1以上へ補正
   */
  handleGiftQuantityInput() {
    if (!this.giftQuantityInput) {
      return;
    }

    const currentValue =
      Number.parseInt(
        this.giftQuantityInput.value,
        10
      );

    if (
      !Number.isFinite(currentValue) ||
      currentValue < 1
    ) {
      this.giftQuantityInput.value = 1;
    }
  }

  /*
   * ギフト包装数の表示・必須状態を更新
   */
  updateGiftState() {
    if (
      !this.giftSelect ||
      !this.giftQuantityWrap ||
      !this.giftQuantityInput
    ) {
      return;
    }

    const isEnabled =
      this.giftSelect.value !== '不要';

    this.giftQuantityWrap.hidden =
      !isEnabled;

    this.giftQuantityWrap.setAttribute(
      'aria-hidden',
      isEnabled ? 'false' : 'true'
    );

    this.giftQuantityInput.disabled =
      !isEnabled;

    this.giftQuantityInput.required =
      isEnabled;

    if (!isEnabled) {
      this.giftQuantityInput.value = 1;
      this.giftQuantityInput.setCustomValidity('');
    }
  }

  /*
   * 刺繍サービス説明を開く
   */
  handleEmbroideryModalOpen(event) {
    event.preventDefault();
    this.openEmbroideryModal();
  }

  /*
   * 刺繍サービス説明を閉じる
   */
  handleEmbroideryModalClose(event) {
    event.preventDefault();
    this.closeEmbroideryModal();
  }

  /*
   * 刺繍サービス説明内のキーボード操作
   */
  handleEmbroideryModalKeydown(event) {
    if (
      !this.embroideryModal ||
      this.embroideryModal.hidden
    ) {
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeEmbroideryModal();
      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    const focusableElements =
      this.getEmbroideryModalFocusableElements();

    if (focusableElements.length === 0) {
      event.preventDefault();
      this.embroideryModalDialog?.focus();
      return;
    }

    const firstElement =
      focusableElements[0];

    const lastElement =
      focusableElements[
        focusableElements.length - 1
      ];

    if (
      event.shiftKey &&
      document.activeElement === firstElement
    ) {
      event.preventDefault();
      lastElement.focus();
      return;
    }

    if (
      !event.shiftKey &&
      document.activeElement === lastElement
    ) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  /*
   * 刺繍サービス説明を表示
   */
  openEmbroideryModal() {
    if (
      !this.embroideryModal ||
      !this.embroideryModalDialog
    ) {
      return;
    }

    this.embroideryModalLastFocused =
      document.activeElement instanceof HTMLElement
        ? document.activeElement
        : null;

    this.embroideryModal.hidden = false;

    this.embroideryModal.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.classList.add(
      'reiando-gift-modal-open'
    );

    document.addEventListener(
      'keydown',
      this.handleEmbroideryModalKeydown
    );

    window.requestAnimationFrame(() => {
      this.embroideryModalDialog?.focus();
    });
  }

  /*
   * 刺繍サービス説明を非表示
   */
  closeEmbroideryModal(restoreFocus = true) {
    if (!this.embroideryModal) {
      return;
    }

    this.embroideryModal.hidden = true;

    this.embroideryModal.setAttribute(
      'aria-hidden',
      'true'
    );

    document.body.classList.remove(
      'reiando-gift-modal-open'
    );

    document.removeEventListener(
      'keydown',
      this.handleEmbroideryModalKeydown
    );

    if (
      restoreFocus &&
      this.embroideryModalLastFocused instanceof HTMLElement
    ) {
      this.embroideryModalLastFocused.focus();
    }

    this.embroideryModalLastFocused = null;
  }

  /*
   * 刺繍モーダル内のフォーカス可能要素
   */
  getEmbroideryModalFocusableElements() {
    if (!this.embroideryModalDialog) {
      return [];
    }

    return Array.from(
      this.embroideryModalDialog.querySelectorAll(
        'a[href], button:not([disabled]), ' +
        'input:not([disabled]), select:not([disabled]), ' +
        'textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => {
      return (
        element instanceof HTMLElement &&
        !element.hidden &&
        element.offsetParent !== null
      );
    });
  }

  /*
   * ギフト包装説明を開く
   */
  handleGiftModalOpen(event) {
    event.preventDefault();
    this.openGiftModal();
  }

  /*
   * ギフト包装説明を閉じる
   */
  handleGiftModalClose(event) {
    event.preventDefault();
    this.closeGiftModal();
  }

  /*
   * ギフト包装説明内のキーボード操作
   */
  handleGiftModalKeydown(event) {
    if (
      !this.giftModal ||
      this.giftModal.hidden
    ) {
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeGiftModal();
      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    const focusableElements =
      this.getGiftModalFocusableElements();

    if (focusableElements.length === 0) {
      event.preventDefault();
      this.giftModalDialog?.focus();
      return;
    }

    const firstElement =
      focusableElements[0];

    const lastElement =
      focusableElements[
        focusableElements.length - 1
      ];

    if (
      event.shiftKey &&
      document.activeElement === firstElement
    ) {
      event.preventDefault();
      lastElement.focus();
      return;
    }

    if (
      !event.shiftKey &&
      document.activeElement === lastElement
    ) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  /*
   * ギフト包装説明を表示
   */
  openGiftModal() {
    if (
      !this.giftModal ||
      !this.giftModalDialog
    ) {
      return;
    }

    this.giftModalLastFocused =
      document.activeElement instanceof HTMLElement
        ? document.activeElement
        : null;

    this.giftModal.hidden = false;

    this.giftModal.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.classList.add(
      'reiando-gift-modal-open'
    );

    document.addEventListener(
      'keydown',
      this.handleGiftModalKeydown
    );

    window.requestAnimationFrame(() => {
      this.giftModalDialog?.focus();
    });
  }

  /*
   * ギフト包装説明を非表示
   */
  closeGiftModal(restoreFocus = true) {
    if (!this.giftModal) {
      return;
    }

    this.giftModal.hidden = true;

    this.giftModal.setAttribute(
      'aria-hidden',
      'true'
    );

    document.body.classList.remove(
      'reiando-gift-modal-open'
    );

    document.removeEventListener(
      'keydown',
      this.handleGiftModalKeydown
    );

    if (
      restoreFocus &&
      this.giftModalLastFocused instanceof HTMLElement
    ) {
      this.giftModalLastFocused.focus();
    }

    this.giftModalLastFocused = null;
  }

  /*
   * モーダル内のフォーカス可能要素
   */
  getGiftModalFocusableElements() {
    if (!this.giftModalDialog) {
      return [];
    }

    return Array.from(
      this.giftModalDialog.querySelectorAll(
        'a[href], button:not([disabled]), ' +
        'input:not([disabled]), select:not([disabled]), ' +
        'textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => {
      return (
        element instanceof HTMLElement &&
        !element.hidden &&
        element.offsetParent !== null
      );
    });
  }

  /*
   * ギフト包装入力を検証
   */
  validateGift() {
    if (
      !this.giftSelect ||
      this.giftSelect.value === '不要'
    ) {
      return true;
    }

    if (!this.giftQuantityInput) {
      return false;
    }

    this.handleGiftQuantityInput();

    const quantity =
      Number.parseInt(
        this.giftQuantityInput.value,
        10
      );

    if (
      !Number.isFinite(quantity) ||
      quantity < 1
    ) {
      this.giftQuantityInput.setCustomValidity(
        '包装数を1以上で入力してください。'
      );

      this.giftQuantityInput.reportValidity();

      return false;
    }

    this.giftQuantityInput.setCustomValidity('');

    return true;
  }

  /*
   * 刺繍サービス商品JSONを取得
   */
  async loadEmbroideryProduct() {
    if (this.embroideryProduct) {
      return this.embroideryProduct;
    }

    if (this.embroideryProductPromise) {
      return this.embroideryProductPromise;
    }

    if (!this.embroideryProductJsonUrl) {
      throw new Error(
        '刺繍サービス商品の参照先が設定されていません。'
      );
    }

    this.embroideryProductPromise = fetch(
      this.embroideryProductJsonUrl,
      {
        headers: {
          Accept: 'application/json'
        }
      }
    )
      .then(async (response) => {
        const result =
          await response.json().catch(() => null);

        if (!response.ok || !result) {
          throw new Error(
            result?.description ||
            result?.message ||
            '刺繍サービス商品を読み込めませんでした。'
          );
        }

        this.embroideryProduct = result;

        return result;
      })
      .catch((error) => {
        this.embroideryProductPromise = null;
        throw error;
      });

    return this.embroideryProductPromise;
  }

  /*
   * 刺繍サービス商品のバリエーションを取得
   */
  async getEmbroideryVariant() {
    const embroideryProduct =
      await this.loadEmbroideryProduct();

    const variants = Array.isArray(
      embroideryProduct.variants
    )
      ? embroideryProduct.variants
      : [];

    const variant = variants.find(
      (embroideryVariant) => {
        return embroideryVariant.available !== false;
      }
    );

    if (!variant) {
      throw new Error(
        '刺繍サービスは現在ご利用いただけません。'
      );
    }

    return variant;
  }

  /*
   * ギフト包装商品JSONを取得
   */
  async loadGiftProduct() {
    if (this.giftProduct) {
      return this.giftProduct;
    }

    if (this.giftProductPromise) {
      return this.giftProductPromise;
    }

    if (!this.giftProductJsonUrl) {
      throw new Error(
        'ギフト包装商品の参照先が設定されていません。'
      );
    }

    this.giftProductPromise = fetch(
      this.giftProductJsonUrl,
      {
        headers: {
          Accept: 'application/json'
        }
      }
    )
      .then(async (response) => {
        const result =
          await response.json().catch(() => null);

        if (!response.ok || !result) {
          throw new Error(
            result?.description ||
            result?.message ||
            'ギフト包装商品を読み込めませんでした。'
          );
        }

        this.giftProduct = result;

        return result;
      })
      .catch((error) => {
        this.giftProductPromise = null;
        throw error;
      });

    return this.giftProductPromise;
  }

  /*
   * 選択中のギフト包装バリエーションを取得
   */
  async getSelectedGiftVariant() {
    if (
      !this.giftSelect ||
      this.giftSelect.value === '不要'
    ) {
      return null;
    }

    const giftProduct =
      await this.loadGiftProduct();

    const selectionMap = {
      'FUROSHIKI／大': ['FUROSHIKI', '大'],
      'FUROSHIKI／小': ['FUROSHIKI', '小'],
      'BAG／大': ['BAG', '大'],
      'BAG／小': ['BAG', '小']
    };

    const targetOptions =
      selectionMap[this.giftSelect.value];

    if (!targetOptions) {
      throw new Error(
        '選択したギフト包装を確認できませんでした。'
      );
    }

    const variants = Array.isArray(
      giftProduct.variants
    )
      ? giftProduct.variants
      : [];

    const variant = variants.find(
      (giftVariant) => {
        const options =
          Array.isArray(giftVariant.options)
            ? giftVariant.options
            : [
                giftVariant.option1,
                giftVariant.option2
              ].filter(Boolean);

        return (
          String(options[0]) ===
            String(targetOptions[0]) &&
          String(options[1]) ===
            String(targetOptions[1])
        );
      }
    );

    if (!variant) {
      throw new Error(
        '選択したギフト包装の価格情報が見つかりません。'
      );
    }

    if (variant.available === false) {
      throw new Error(
        '選択したギフト包装は現在ご利用いただけません。'
      );
    }

    return variant;
  }

  /*
   * 商品フォームからラインアイテムプロパティを作成
   */
  getProductProperties() {
    if (!this.form) {
      return {};
    }

    const properties = {};
    const formData = new FormData(this.form);

    formData.forEach((value, key) => {
      const match = key.match(
        /^properties\[(.+)\]$/
      );

      if (!match) {
        return;
      }

      const propertyValue =
        String(value).trim();

      if (propertyValue === '') {
        return;
      }

      properties[match[1]] =
        propertyValue;
    });

    return properties;
  }

  /*
   * 商品・刺繍サービス・ギフト包装を一括でカート追加
   */
  async addProductWithServices({
    hasEmbroidery,
    hasGift
  }) {
    const productQuantity =
      this.getProductQuantity();

    const baseProductProperties =
      this.getProductProperties();

    /*
     * 刺繍関連は各商品ごとに作成するため、
     * フォーム共通プロパティから除外する
     */
    delete baseProductProperties['イニシャル刺繍サービス'];
    delete baseProductProperties['刺繍する文字'];
    delete baseProductProperties['刺繍カラー'];

    const items = [];

    let embroideryVariant = null;
    let embroiderySelections = [];

    if (hasEmbroidery) {
      embroideryVariant =
        await this.getEmbroideryVariant();

      embroiderySelections =
        this.getEmbroiderySelections();

      if (
        embroiderySelections.length !==
        productQuantity
      ) {
        throw new Error(
          '商品数量分の刺繍内容を入力してください。'
        );
      }
    }

    let giftVariant = null;
    let giftLinkId = '';

    if (hasGift) {
      giftVariant =
        await this.getSelectedGiftVariant();

      if (!giftVariant) {
        throw new Error(
          'ギフト包装を確認できませんでした。'
        );
      }

      giftLinkId = this.createLinkId();
    }

    if (hasEmbroidery && embroideryVariant) {
      embroiderySelections.forEach((selection) => {
        const embroideryLinkId =
          this.createLinkId();

        const productProperties = {
          ...baseProductProperties,
          _刺繍連携ID: embroideryLinkId,
          _刺繍商品番号:
            String(selection.itemNumber)
        };

        if (giftLinkId) {
          productProperties._ギフト包装連携ID =
            giftLinkId;
        }

        items.push({
          id: Number(this.currentVariant.id),
          quantity: 1,
          properties: productProperties
        });

        items.push({
          id: Number(embroideryVariant.id),
          quantity: 1,
          properties: {
            対象商品:
              this.productTitle || '商品',
            刺繍する文字:
              selection.character,
            刺繍カラー:
              selection.color,
            _reiando_addon_type:
              'embroidery',
            _対象商品バリエーションID:
              String(this.currentVariant.id),
            _刺繍連携ID:
              embroideryLinkId,
            _刺繍商品番号:
              String(selection.itemNumber)
          }
        });
      });
    } else {
      const productProperties = {
        ...baseProductProperties
      };

      if (giftLinkId) {
        productProperties._ギフト包装連携ID =
          giftLinkId;
      }

      items.push({
        id: Number(this.currentVariant.id),
        quantity: productQuantity,
        properties: productProperties
      });
    }

    if (hasGift && giftVariant) {
      const giftQuantity =
        Number.parseInt(
          this.giftQuantityInput?.value,
          10
        ) || 1;

      items.push({
        id: Number(giftVariant.id),
        quantity: giftQuantity,
        properties: {
          _対象商品:
            this.productTitle || '商品',
          _対象商品バリエーションID:
            String(this.currentVariant.id),
          _ギフト包装連携ID: giftLinkId
        }
      });
    }

    const response = await fetch(
      this.cartAddUrl,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type':
            'application/json',
          'X-Requested-With':
            'XMLHttpRequest'
        },
        body: JSON.stringify({ items })
      }
    );

    const result =
      await response.json();

    if (!response.ok) {
      throw new Error(
        result.description ||
        result.message ||
        'カートへの追加に失敗しました。'
      );
    }

    return result;
  }

  /*
   * 商品と付帯サービスを結ぶIDを作成
   */
  createLinkId() {
    return [
      Date.now(),
      Math.random()
        .toString(36)
        .slice(2, 10)
    ].join('-');
  }

  /*
   * バリエーション情報を画面へ反映
   */
  updateVariantState(updateUrl = true) {
    const variant = this.currentVariant;

    if (!variant) {
      if (this.variantInput) {
        this.variantInput.value = '';
      }

      if (this.addButton) {
        this.addButton.disabled = true;
      }

      if (this.addButtonText) {
        this.addButtonText.textContent =
          '選択できません';
      }

      this.setMessage(
        '選択した組み合わせはご利用いただけません。',
        true
      );

      return;
    }

    if (this.variantInput) {
      this.variantInput.value = variant.id;
    }

    if (this.priceElement) {
      this.priceElement.textContent =
        this.formatMoney(
          variant.price,
          this.moneyFormat
        );
    }

    this.updateAddButton(variant);
    this.setMessage('');

    if (updateUrl) {
      this.updateProductUrl(variant.id);
    }
  }

  /*
   * カートボタン状態
   */
  updateAddButton(variant) {
    if (
      !this.addButton ||
      !this.addButtonText
    ) {
      return;
    }

    if (this.isSubmitting) {
      this.addButton.disabled = true;

      this.addButtonText.textContent =
        'ADDING...';

      return;
    }

    if (variant.available) {
      this.addButton.disabled = false;

      this.addButtonText.textContent =
        'ADD TO CART';
    } else {
      this.addButton.disabled = true;

      this.addButtonText.textContent =
        'SOLD OUT';
    }
  }

  /*
   * URLへバリエーションIDを反映
   */
  updateProductUrl(variantId) {
    if (
      !this.productUrl ||
      !window.history?.replaceState
    ) {
      return;
    }

    const url = new URL(
      this.productUrl,
      window.location.origin
    );

    url.searchParams.set(
      'variant',
      variantId
    );

    window.history.replaceState(
      {},
      '',
      `${url.pathname}${url.search}${url.hash}`
    );
  }

  /*
   * 数量を減らす
   */
  handleQuantityMinus() {
    if (!this.quantityInput) {
      return;
    }

    const currentValue =
      Number.parseInt(
        this.quantityInput.value,
        10
      ) || 1;

    this.quantityInput.value = Math.max(
      1,
      currentValue - 1
    );

    this.updateEmbroideryState();
  }

  /*
   * 数量を増やす
   */
  handleQuantityPlus() {
    if (!this.quantityInput) {
      return;
    }

    const currentValue =
      Number.parseInt(
        this.quantityInput.value,
        10
      ) || 1;

    this.quantityInput.value =
      currentValue + 1;

    this.updateEmbroideryState();
  }

  /*
   * 数量を1以上へ補正
   */
  handleQuantityInput() {
    if (!this.quantityInput) {
      return;
    }

    const currentValue =
      Number.parseInt(
        this.quantityInput.value,
        10
      );

    if (
      !Number.isFinite(currentValue) ||
      currentValue < 1
    ) {
      this.quantityInput.value = 1;
    }

    this.updateEmbroideryState();
  }

  /*
   * カート追加
   */
  async handleSubmit(event) {
    event.preventDefault();

    if (
      !this.form ||
      !this.currentVariant ||
      !this.currentVariant.available ||
      this.isSubmitting
    ) {
      return;
    }

    this.handleQuantityInput();
    this.updateEmbroideryState();
    this.updateGiftState();

    if (!this.validateEmbroidery()) {
      return;
    }

    if (!this.validateGift()) {
      return;
    }

    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }

    this.isSubmitting = true;

    this.updateAddButton(
      this.currentVariant
    );

    this.setMessage('');

    try {
      const hasEmbroidery =
        this.embroiderySelect &&
        this.embroiderySelect.value === '希望する';

      const hasGift =
        this.giftSelect &&
        this.giftSelect.value !== '不要';

      if (hasEmbroidery || hasGift) {
        await this.addProductWithServices({
          hasEmbroidery,
          hasGift
        });
      } else {
        const formData =
          new FormData(this.form);

        const response = await fetch(
          this.cartAddUrl,
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With':
                'XMLHttpRequest'
            },
            body: formData
          }
        );

        const result =
          await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            result.message ||
            'カートへの追加に失敗しました。'
          );
        }
      }

      await this.updateCartCount();

      this.setMessage(
        '商品をカートに追加しました。'
      );
    } catch (error) {
      console.error(
        'カートへの追加に失敗しました。',
        error
      );

      this.setMessage(
        error.message ||
        'カートへの追加に失敗しました。',
        true
      );
    } finally {
      this.isSubmitting = false;

      this.updateAddButton(
        this.currentVariant
      );
    }
  }

  /*
   * カート情報を取得
   */
  async updateCartCount() {
    try {
      const response = await fetch(
        this.cartJsonUrl,
        {
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!response.ok) {
        return;
      }

      const cart =
        await response.json();

      this.updateCartBadges(
        cart.item_count || 0
      );
    } catch (error) {
      console.error(
        'カート件数を更新できませんでした。',
        error
      );
    }
  }

  /*
   * ヘッダーのカート件数を更新
   */
  updateCartBadges(itemCount) {
    const cartLinks =
      document.querySelectorAll(
        '.reiando-header__cart, ' +
        '.reiando-header__fixed-cart'
      );

    cartLinks.forEach((cartLink) => {
      let badge = cartLink.querySelector(
        '.reiando-header__cart-count'
      );

      if (itemCount > 0) {
        if (!badge) {
          badge =
            document.createElement('span');

          badge.className =
            'reiando-header__cart-count';

          cartLink.appendChild(badge);
        }

        badge.textContent = itemCount;
      } else if (badge) {
        badge.remove();
      }

      cartLink.setAttribute(
        'aria-label',
        `カートを開く。商品数：${itemCount}`
      );
    });
  }

  /*
   * メッセージ表示
   */
  setMessage(message, isError = false) {
    if (!this.messageElement) {
      return;
    }

    this.messageElement.textContent =
      message;

    this.messageElement.classList.toggle(
      'is-error',
      isError
    );
  }

  /*
   * Shopifyの価格書式
   */
  formatMoney(cents, format) {
    const formatString =
      format || '{{amount}}';

    const placeholderRegex =
      /\{\{\s*(\w+)\s*\}\}/;

    const match =
      formatString.match(
        placeholderRegex
      );

    if (!match) {
      return String(cents);
    }

    let value = '';

    switch (match[1]) {
      case 'amount':
        value =
          this.formatWithDelimiters(
            cents,
            2,
            ',',
            '.'
          );
        break;

      case 'amount_no_decimals':
        value =
          this.formatWithDelimiters(
            cents,
            0,
            ',',
            '.'
          );
        break;

      case 'amount_with_comma_separator':
        value =
          this.formatWithDelimiters(
            cents,
            2,
            '.',
            ','
          );
        break;

      case 'amount_no_decimals_with_comma_separator':
        value =
          this.formatWithDelimiters(
            cents,
            0,
            '.',
            ','
          );
        break;

      case 'amount_with_apostrophe_separator':
        value =
          this.formatWithDelimiters(
            cents,
            2,
            "'",
            '.'
          );
        break;

      default:
        value =
          this.formatWithDelimiters(
            cents,
            2,
            ',',
            '.'
          );
    }

    return formatString.replace(
      placeholderRegex,
      value
    );
  }

  /*
   * 数値を通貨用に整形
   */
  formatWithDelimiters(
    cents,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    const value = Number(cents);

    if (!Number.isFinite(value)) {
      return '0';
    }

    const number =
      (value / 100).toFixed(
        precision
      );

    const parts =
      number.split('.');

    const integerPart =
      parts[0].replace(
        /(\d)(?=(\d{3})+(?!\d))/g,
        `$1${thousands}`
      );

    if (precision === 0) {
      return integerPart;
    }

    return (
      integerPart +
      decimal +
      (
        parts[1] ||
        ''.padEnd(precision, '0')
      )
    );
  }

  /*
   * イベント解除
   */
  destroy() {
    this.optionInputs.forEach((input) => {
      input.removeEventListener(
        'change',
        this.handleOptionChange
      );
    });

    this.quantityMinus?.removeEventListener(
      'click',
      this.handleQuantityMinus
    );

    this.quantityPlus?.removeEventListener(
      'click',
      this.handleQuantityPlus
    );

    this.quantityInput?.removeEventListener(
      'change',
      this.handleQuantityInput
    );

    this.quantityInput?.removeEventListener(
      'blur',
      this.handleQuantityInput
    );

    this.embroiderySelect?.removeEventListener(
      'change',
      this.handleEmbroideryChange
    );

    this.embroideryItemsContainer?.removeEventListener(
      'input',
      this.handleEmbroideryCharacterInput
    );

    this.embroideryModalOpenButton?.removeEventListener(
      'click',
      this.handleEmbroideryModalOpen
    );

    this.embroideryModalCloseButtons.forEach((button) => {
      button.removeEventListener(
        'click',
        this.handleEmbroideryModalClose
      );
    });

    document.removeEventListener(
      'keydown',
      this.handleEmbroideryModalKeydown
    );

    if (
      this.embroideryModal &&
      !this.embroideryModal.hidden
    ) {
      this.closeEmbroideryModal(false);
    }

    this.giftSelect?.removeEventListener(
      'change',
      this.handleGiftChange
    );

    this.giftQuantityInput?.removeEventListener(
      'change',
      this.handleGiftQuantityInput
    );

    this.giftQuantityInput?.removeEventListener(
      'blur',
      this.handleGiftQuantityInput
    );

    this.giftModalOpenButton?.removeEventListener(
      'click',
      this.handleGiftModalOpen
    );

    this.giftModalCloseButtons.forEach((button) => {
      button.removeEventListener(
        'click',
        this.handleGiftModalClose
      );
    });

    document.removeEventListener(
      'keydown',
      this.handleGiftModalKeydown
    );

    if (
      this.giftModal &&
      !this.giftModal.hidden
    ) {
      this.closeGiftModal(false);
    }

    this.form?.removeEventListener(
      'submit',
      this.handleSubmit
    );
  }
}


/*
 * 商品詳細セクションを初期化
 */
function initializeReiandoMainProduct(
  root = document
) {
  const sections = [];

  if (
    root instanceof Element &&
    root.matches(
      '[data-reiando-product]'
    )
  ) {
    sections.push(root);
  }

  root
    .querySelectorAll?.(
      '[data-reiando-product]'
    )
    .forEach((section) => {
      sections.push(section);
    });

  sections.forEach((section) => {
    if (
      section.dataset
        .reiandoProductInitialized ===
      'true'
    ) {
      return;
    }

    section.dataset
      .reiandoProductInitialized =
      'true';

    section.reiandoMainProduct =
      new ReiandoMainProduct(section);
  });
}


/*
 * 通常ページ読み込み
 */
document.addEventListener(
  'DOMContentLoaded',
  () => {
    initializeReiandoMainProduct();
  }
);


/*
 * Shopifyテーマエディター
 */
document.addEventListener(
  'shopify:section:load',
  (event) => {
    initializeReiandoMainProduct(
      event.target
    );
  }
);

document.addEventListener(
  'shopify:section:unload',
  (event) => {
    const section =
      event.target.querySelector(
        '[data-reiando-product]'
      );

    if (
      !section?.reiandoMainProduct
    ) {
      return;
    }

    section.reiandoMainProduct.destroy();
  }
);